import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./join.css";
const Join = () => {
	const [name, setName] = useState("");
	const [room, setRoom] = useState("");
    const [displayreadme, setDisplayreadme] = useState("none")
    const [displaypleasereadme, setDisplaypleasereadme] = useState("block")

    const DisplayReadMe = (data) =>{
    	setDisplayreadme(data)
    	if(data === "block") {
    		setDisplaypleasereadme("none")
    	}
        else {
        	setDisplaypleasereadme("block")
        }
    }
	return (
		<div className="joinOuterContainer">
		 <p className="pleasereadme" style={{display:displaypleasereadme}} onClick={()=>DisplayReadMe("block")}><bold>&#9758;</bold> <em>please readme</em></p>

		 <div className="readme" style={{display: displayreadme}}>

				  <p className="closereadme" onClick={()=> DisplayReadMe("none")}>X</p>

				   <h3>Right on before testing the app, please read the below guildelines</h3>
				   <h5>Joining Chat</h5>
				   <div>
						   <p>
						     Before you join the chat, you should enable you enter your <em> name</em> and the<em> room</em> you want your chat to display in.</p>
				     </div>
				     <h5>Image Upload</h5>
				     <div>

						   <p>
						     After you have passed in your name & room, and you have clicked  <strong>join chat</strong>, the web page will be navigated to a page where you can upload your image.
						       <p><i> To upload image, you have to click on the button <strong>Browse</strong>. After selecting your image, your image will be displayed. Then you can click the <strong>upload icon</strong> beside the Browse button to finally upload your image.</i>
						        </p>
						        <p>Note: if you do not want to upload an image, you could skip the above steps and just click the <strong>upload icon</strong> to submit an empty image.
						        </p> 
						   </p>
				    </div>
				    <h5>Sending and Receiving messages</h5> 
				    <div>
						   <p>
						      Note: for you to receive message from another user, you and the other user must be in the same room i.e <i>when joining the chat, the room you entered must be corresponding to the room your other friend entered, else no message will be transmitted. </i></p>
				    </div>
					<h5>Online Friends</h5>
					<div>
				            <p>
				               You can also view friends that are online and in the same room with you, <strong>by clicking on the top right icon, that display your name with a down face arror by the side.</strong>
				            </p>
		            </div>
		            <h5>Logging Out</h5>
		            <div>
				            <p>
				            Note: when through with the chat, you can close it by clicking on the top right white logo <strong>X</strong> that looks like a cross sword. <i>Ensure you do this to enable the app delete all the cache data.</i>
				            </p>
		            </div>

		 </div>
			<div className="joinInnerContainer">
			  <h3>M</h3>
			  <p>Chat App</p>
			  <i>mosboy</i>
					<div> 
						<input
							placeholder="Name"
							className="joinInput"
							type="text"
							onChange={(event) => setName(event.target.value)}
							autoComplete
						/> 
					</div>
					<div>
						<input
							placeholder="Room"
							className="joinInput"
							type="text"
							onChange={(event) => setRoom(event.target.value)}
							autoComplete="true"
						/>
					</div>
				
					<Link
						onClick={
							(event) =>

								!name || !room
									? event.preventDefault()
									: null/*the onclick function will make the body only submit the to the url if the name and room is already passed in the the input tag*/
						}
						to={`/image?name=${name}&room=${room}`}
					>
						<button className="button mt-20" type="submit" >
							Join Chat
						</button>
					</Link>
			</div>
		</div>
	);
};
export default Join;
